import { cn } from "@/lib/utils";

export function Segmented<T extends string>({ options, value, onChange, ariaLabel }: {
  options: { id: T; label: string; badge?: string | null }[];
  value: T;
  onChange: (id: T) => void;
  ariaLabel: string;
}) {
  return (
    <nav aria-label={ariaLabel} className="flex gap-0.5 rounded-md bg-muted p-0.5 max-w-full overflow-x-auto">
      {options.map((o) => (
        <button key={o.id} type="button" aria-pressed={o.id === value} onClick={() => onChange(o.id)}
          className={cn("px-2.5 py-1 text-xs font-medium rounded whitespace-nowrap transition-colors",
            o.id === value ? "bg-background text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground")}>
          {o.label}
          {o.badge && <span className="ml-1 text-[9px] font-semibold uppercase tracking-wide text-muted-foreground">{o.badge}</span>}
        </button>
      ))}
    </nav>
  );
}
